import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { Routes, RouterModule } from '@angular/router';


import { AngularFireModule } from '@angular/fire';
import { AngularFireStorageModule } from '@angular/fire/storage';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';


import { Approutes } from './app-routing.module';
import { AppComponent } from './app.component';

import { SpinnerComponent } from './shared/spinner.component';
import { SnackbarComponent } from './shared/snackbar/snackbar.component';
import { LoadingComponent } from './shared/loading/loading.component';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import {MatTabsModule, MatCheckbox, MatCheckboxModule, MatCardModule, MatSortModule} from '@angular/material'
import {ReactiveFormsModule} from '@angular/forms';
import 
{ 
  DialogComponent,
  DialogContentDialog,
  DialogDataDialog,
  DialogDetailDialog,
  DialogListDialog,
  DialogSuccessDialog,
  DialogInputDataDialog
} from './shared/dialog/dialog.component';



import { IntlInputPhoneModule ,ConfigurationOptions } from 'intl-input-phone';
import { UsersService } from './services/users/users.service';
import { LoadingService } from './services/loading/loading.service';

import { MatDialogModule } from '@angular/material';
import {MatBadgeModule} from '@angular/material/badge';
import { SortPipe } from './sort.pipe';
import { AgmCoreModule } from '@agm/core';


import {
  MatButtonModule,
  MatIconModule,
  MatFormFieldModule,
  MatInputModule,
  MatRippleModule,
  MatTooltipModule,
  MatTableModule,
  MatPaginatorModule,
  MatRadioModule,
  MatSelectModule,
  MatListModule,
  MatSnackBarModule,
  MatProgressSpinnerModule,
  
  
} from '@angular/material';


import { environment } from '../environments/environment';
import { OrderDialogComponent } from './admin/orders/order-dialog/order-dialog.component';


const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};
@NgModule({
  entryComponents:[
    DialogComponent,
    DialogContentDialog,
    DialogDataDialog,
    OrderDialogComponent,
    DialogDetailDialog,
    DialogListDialog,
    DialogSuccessDialog,
    DialogInputDataDialog,
    
  ],
  declarations: [
    AppComponent,
    SpinnerComponent,
    SnackbarComponent,
    LoadingComponent,
    DialogComponent,
    DialogContentDialog,
    DialogDataDialog,
    OrderDialogComponent,
    DialogDetailDialog,
    DialogListDialog,
    DialogSuccessDialog,
    DialogInputDataDialog,
    SortPipe
    
  ],
  imports: [
    CommonModule,
    AngularFireModule.initializeApp(environment.firebase),
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    AngularFireStorageModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    MatDialogModule,
    MatBadgeModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatCheckboxModule,
    MatInputModule,
    MatCardModule,
    MatRippleModule,
    MatTooltipModule,
    MatTableModule,
    MatPaginatorModule,
    IntlInputPhoneModule,
    MatRadioModule,
    MatSelectModule,
    MatListModule,
    MatSnackBarModule,
    MatProgressSpinnerModule,
    NgbModule.forRoot(),
    RouterModule.forRoot(Approutes),
    PerfectScrollbarModule,
    MatTabsModule,
    ReactiveFormsModule,
    MatSortModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyCWJzX87tYN9PJ7CNFM5WVs5kcrTeMlrGc',
      libraries: ['places'] 
    }),
    

  ],
  providers:[
    UsersService,
    LoadingService, 
    SnackbarComponent,
    DialogComponent,
    DialogDataDialog,
    DialogListDialog,
    DialogDetailDialog,
    DialogContentDialog,
    ConfigurationOptions,
    DialogSuccessDialog,
    SortPipe,
    DialogInputDataDialog,
    
    
    {   
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    }
    
  ],
  exports:[
    LoadingComponent,
    OrderDialogComponent,
    
    

  ],
  bootstrap: [AppComponent,LoadingComponent]
})
export class AppModule {}
